<template>
  <div class="text--center">
    <component
      :is="url ? 'nuxt-link' : 'div'"
      :to="url"
      :data-tealium-rel="tealiumRel"
    >
      <GoliathImageElement
        v-if="goliathImage"
        :image="goliathImage"
        :alt="title"
        class="order-table-item-image"
        render-without-figure
      />
      <CdnImage
        v-else
        :alt="title"
        :src="imagePath"
        class="order-table-item-image"
        render-without-figure
      />
    </component>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { type LocalImage } from '@i22/rocket';
import { GoliathImageElement, slugify } from '@i22-td-smarthome/component-library';
import CdnImage from '@/components/cdn-image.vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  url: {
    type: String,
    required: false,
    default: '',
  },
  imagePath: {
    type: String,
    required: true,
  },
});

const tealiumRel = computed(() => `content.image.${slugify(props.title)}`);

const goliathImage = computed<LocalImage>(() => {
  if (!props.imagePath.startsWith('/public')) return undefined;
  const mediaId = props.imagePath.replace(/^\/public\/([^/]+)\/.*/, '$1');
  return {
    name: props.title,
    mediaId,
  };
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.order-table-item-image {
  width: 100%;
  margin-inline: auto;
  @include mq($mq-sm, $mq-md - 1) {
    max-width: 130px;
  }
}
</style>
